import '../styles/general.scss'
import '../styles/icomoon.scss'
import '../styles/print.scss'

import './showtime/showtime.scss'

import React from 'react';
import _ from 'lodash'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Switch, Route, withRouter, BrowserRouter } from 'react-router-dom'
import { getParams } from '../utilities/location-utilities'
import { ROUTES } from './navigation/route-constants'
import { APP_MODES } from '../api/api-constants'
import { appHeightChanged, initFromParentSite } from '../actions/app-actions'
import Program_AllFutureMovies from './movielists/combinations/Program_AllFutureMovies'

// NEW PROGRAM WITH FUTURE FILM ROUTE
import Program_AllFutureMoviesV2 from './movielists/combinations/Program_AllFutureMoviesv2'

import Multibio_ProgramContainer from './movielists/multibio/Multibio_ProgramContainer'
import Multibio_AllContainer from './movielists/multibio/Multibio_AllContainer'
import Multibio_FutureMoviesContainer from './movielists/multibio/futuremovies/Multibio_FutureMoviesContainer'

// NEW MULTI V2 ROUTES
import Multibio_ProgramContainerV2 from './movielists/multibiov2/Multibio_ProgramContainer'
import Multibio_AllContainerV2 from './movielists/multibiov2/Multibio_AllContainer'
import Multibio_FutureMoviesContainerV2 from './movielists/multibiov2/futuremovies/Multibio_FutureMoviesContainer'

import ProgramListContainer from './movielists/program/ProgramListContainer'
import AllMoviesListContainer from './movielists/allmovies/AllMoviesListContainer'
// NEW ALLE FILM V2 ROUTE
import AllMoviesListContainerv2 from './movielists/allmoviesv2/AllMoviesListContainer'

import FutureMoviesListContainer from './movielists/futuremovies/FutureMoviesListContainer'
// NEW FUTURE FILM ROUTE
import FutureMoviesListContainerv2 from './movielists/futuremoviesv2/FutureMoviesListContainer'

import SpecialEventsContainer from './movielists/specialevents/SpecialEventsContainer'

import TicketMasterListContainer from './external/ticketmaster/TicketMasterListContainer'
import TicketMasterDetailsContainer from './external/ticketmaster/TicketMasterDetailsContainer'
import BillettenListContainer from './external/billetten/BillettenListContainer'
import BillettenDetailsContainer from './external/billetten/BillettenDetailsContainer'

// NEW PROGRAM ROUTE
import ProgramListContainerV2 from './movielists/programv2/ProgramListContainer'

// NEW WEEK PROGRAM ROUTE
import WeekProgramListContainer from './movielists/weekprogram/WeekProgramListContainer'
import WeekProgramListContainer2 from './movielists/weekprogram2/WeekProgramListContainer2'

//NEW WEEK PROGRAM V2
import WeekProgramListContainerV2 from './movielists/weekprogramv2/WeekProgramListContainer2'

import CircusListContainer from './circus/CircusListContainer'
import MovieContainer from './movie/MovieContainer' 
import MovieContainerV2 from './moviev2/MovieContainer' // new film-infov2
import MultiMovieContainerV2 from './movie-multiv2/MovieContainer' // multibio-film-infov2

import OrderFlowContainer from './orderflow/OrderFlowContainer'
import Spinner from './overlays/Spinner'
import Error from './overlays/Error'
import NotFound from './overlays/NotFound'
import CommercialsContainer from './commercials/CommercialsContainer'
import TransactionsContainer from './user/transactions/TransactionsContainer'
import NewslettersContainer from './user/newsletters/NewslettersContainer'
import NewslettersContainerv2 from './user/newslettersv2/NewslettersContainerv2'

import FilmClubContainer from './movielists/filmclub/FilmClubContainer'
import FilmClubOrderContainer from './orderflow/order/FilmClubOrderContainer'
import FilmClubCustomerContainer from './orderflow/customer/FilmClubCustomerContainer';
import ReepayContainerMulti from './orderflow/payment/ReepayContainerMulti'
import ReceiptContainerMulti from './orderflow/receipt/ReceiptContainerMulti'
import ReepayMultiLandingPage from './orderflow/payment/ReepayMultiLandingPage'
import AltaPaymentMulti from './orderflow/payment/AltaPaymentContainerMulti'


// new book routes
import ReepayLandingPage from './ReepayLandingPage'
import BookReciept from './orderflow/receipt/BookReciept'

// EBILLET WEBSITE ROUTES

import EbilletHome from './ebillet/EbilletHome'
//import EbilletProgram from './ebillet/EbilletProgram'
import EbilletFilmDetails from './ebillet/EbilletFilmDetails'
import EbilletMovieContainer from './ebillet/EbilletMovieContainer'

import Biograf from './ebillet/Biograf';
import AllTrailers from './ebillet/AllTrailers'
import FutureFilms from './ebillet/FutureFilms'


// USER LOGIN ROUTES

import LoginState from './loginflow/LoginState';
import Logout from './loginflow/Logout';
import CreateAccount from './loginflow/CreateAccount';
import FinishAccount from './loginflow/FinishAccount';
import ResetPassword from './loginflow/ResetPassword'
import ResetPasswordSuccess from './loginflow/ResetPasswordSuccess'

import ProfileState from './loginflow/ProfileState'
import NewPassword from './loginflow/NewPassword'



class App extends React.Component {
   

    constructor(props) {
        super(props);
        const queryParameters = getParams();
        this.state = {
            app: this.initializeApp(props.mode),
            iframeId: queryParameters.iframeid,
           
        }
        this.checkIfAppHeightChanged = this.checkIfAppHeightChanged.bind(this);
      

    }
  
    componentDidMount() {
        // Sometimes the onLoad isn't triggered on <App (fx in TransactionContainer) so we put an extra height check after mount.
        if (window.parent != window) {
            const { iframeId } = this.state;
            const { actions } = this.props;
            const queryParameters = getParams();
            actions.appHeightChanged(iframeId);
            actions.initFromParentSite(queryParameters.origin); //TODO put iframeId here and maybe also first app height change instead of using onLoad?
        }
        else window.scrollTo(0, 0);
      //  console.log(window.location.pathname)

        const params = new URLSearchParams(window.location.search);
        const news_letter = params.get("nb");
     //   console.log(news_letter)
       news_letter && sessionStorage.setItem('newsletter_no', news_letter)
    }

    //This is for handling dynamic height when inside an iframe
    checkIfAppHeightChanged(e) {
        if (window.parent != window) {
            const { iframeId } = this.state;
            const { actions } = this.props;
            actions.appHeightChanged(iframeId);
        }
    }

    ticketMasterAllEventsRoute = <Route path={ROUTES.TICKETMASTER_ALL_EVENTS} component={TicketMasterListContainer} />;
    ticketMasterEventRoute = <Route path={ROUTES.TICKETMASTER_EVENT + '/:eventId'} component={TicketMasterDetailsContainer} />;
    billettenAllEventsRoute = <Route path={ROUTES.BILLETTEN_ALL_EVENTS} component={BillettenListContainer} />;
    billettenEventRoute = <Route path={ROUTES.BILLETTEN_EVENT + '/:eventId'} component={BillettenDetailsContainer} />;

    multiAllMoviesRoute = <Route exact path={ROUTES.MULTI_ALL_MOVIES} component={Multibio_AllContainer} />;
    multiProgramRoute = <Route exact path={ROUTES.MULTI_PROGRAM + '/:date?'} component={Multibio_ProgramContainer} />;
    multiFutureMoviesRoute = <Route exact path={ROUTES.MULTI_FUTURE_MOVIES} component={Multibio_FutureMoviesContainer} />;

    multiAllMoviesRouteV2 = <Route exact path={ROUTES.MULTI_ALL_MOVIESV2} component={Multibio_AllContainerV2} />;
    multiProgramRouteV2 = <Route exact path={ROUTES.MULTI_PROGRAMV2 + '/:date?'} component={Multibio_ProgramContainerV2} />;
    multiFutureMoviesRouteV2 = <Route exact path={ROUTES.MULTI_FUTURE_MOVIESV2} component={Multibio_FutureMoviesContainerV2} />;

    program_AllFutureMoviesRoute = <Route path={ROUTES.PROGRAM_AND_ALL_FUTURE_MOVIES} component={Program_AllFutureMovies} />;
    // NEW PROGRAM WITH FUTURE ROUTE
    program_AllFutureMoviesRouteV2 = <Route path={ROUTES.PROGRAM_AND_ALL_FUTURE_MOVIESV2} component={Program_AllFutureMoviesV2} />;


    allMoviesRoute = <Route path={ROUTES.ALL_MOVIES} component={AllMoviesListContainer} />;
    allMoviesRouteV2 = <Route path={ROUTES.ALL_MOVIESV2} component={AllMoviesListContainerv2} />;


    programRoute = <Route path={ROUTES.PROGRAM + '/:date?'} component={ProgramListContainer} />;
    programV2Route = <Route path={ROUTES.PROGRAMV2 + '/:date?'} component={ProgramListContainerV2} />

    weekProgramRoute = <Route path={ROUTES.WEEK_PROGRAM} component={WeekProgramListContainer} />;

    // new week program route
    weekProgramRoute2 = <Route path={ROUTES.WEEK_PROGRAM_2} component={WeekProgramListContainer2} />;
   
    // new week program v2 route
    weekProgramRoute2V2 = <Route path={ROUTES.WEEK_PROGRAM2V2} component={WeekProgramListContainerV2} />;

    filmClubRoute = <Route path={ROUTES.FILMCLUB} component={FilmClubContainer} />
   // filmClubOrderFlowRoute = <Route path={'/:page/'} component={FilmClubOrderFlowContainer} />
    filmClubOrderContainer = <Route path={ROUTES.MULTI_TICKETS + '/:eventId'} component={FilmClubOrderContainer} />
    altaPayMulti = <Route path={ROUTES.ALTA_PAY_PAYMENT_MULTI + '/:eventId'} component={AltaPaymentMulti}/>
    FilmClubCustomerContainerRoute = <Route path={ROUTES.FILMCLUB_CUSTOMER + '/:eventId'} component={FilmClubCustomerContainer} />
    FilmClubReepayContainerRoute = <Route path={ROUTES.FILMCLUB_REEPAY + '/:eventId'} component={ReepayContainerMulti} />
    FilmClubReceiptContainerRoute = <Route path={ROUTES.FILMCLUB_RECEIPT } component={ReceiptContainerMulti} />
    FilmClubReepayLandingPage = <Route path={ROUTES.FILMCLUB_REEPAY_LANDING} component={ReepayMultiLandingPage} />

    // USER LOGIN ROUTES
    createAccountRoute = <Route path={ROUTES.CREATE_ACCOUNT} component={CreateAccount} />
    finishAccountRoute = <Route path={ROUTES.FINISH_ACCOUNT} component={FinishAccount} />
    loginRoute         = <Route path={ROUTES.LOGIN} component={LoginState} />
    logoutRoute        = <Route path={ROUTES.LOGOUT} component={Logout } />
    resetPasswordRoute = <Route path={ROUTES.RESET_PASSWORD} component={ResetPassword} />
    resetPasswordSuccessRoute = <Route path={ROUTES.RESET_PASSWORD_SUCCESS} component={ResetPasswordSuccess} />
    
    profileRoute = <Route path={ROUTES.PROFILE+''} component={ProfileState} />
    newPasswordRoute = <Route path={ROUTES.NEW_PASSWORD} component={NewPassword} />

  

    //EBILLET WEBSITE ROUTES
    ebilletHomeRoute =       <Route path={ROUTES.EBILLET_HOME} component={EbilletHome} />
   // ebilletProgramRoute = <Route path={ROUTES.EBILLET_PROGRAM} component={EbilletProgram} />
    ebilletAllTrailers = <Route path={ROUTES.EBILLET_ALL_TRAILER} component={AllTrailers} />
    //ebilletAllMoviesRoute= <Route path={ROUTES.ALL_EBILLET_MOVIES} component={AllEbilletMovies} />   
    EbilletMovieDetails = <Route path={ROUTES.EBILLET_MOVIE_DETAILS + ''} component={EbilletFilmDetails} />  
    ebilletBiografRoute = <Route path={ROUTES.EBILLET_BIOS} component={Biograf} />
    allFutureFilmRoute = <Route path={ROUTES.EBILLET_FUTURE_MOVIES} component={FutureFilms} />          
          
 
    speicalEventsRoute = <Route path={ROUTES.SPECIAL_EVENTS + '/:currentMonth?'} component={SpecialEventsContainer} />;
    futureMoviesRoute = <Route path={ROUTES.FUTURE_MOVIES} component={FutureMoviesListContainer} />;
    // NEW FUTURE FILM ROUTE
    futureMoviesRouteV2 = <Route path={ROUTES.FUTURE_MOVIESV2} component={FutureMoviesListContainerv2} />;

    circusRoute = <Route exact path={ROUTES.CIRCUS} component={CircusListContainer} />;

    movieRoute = <Route path={ROUTES.MOVIE + '/:movieId'} component={MovieContainer} />;
    movieRouteV2 = <Route path={ROUTES.MOVIEV2 + '/:movieId'} component={MovieContainerV2} />;
    multiMovieRouteV2 = <Route  path={ROUTES.MULTI_MOVIEV2 + '/:movieId'} component={MultiMovieContainerV2 } />

    reepayLandingRoute = <Route path={ROUTES.REEPAY_LANDING} component={ReepayLandingPage} />;
    bookReceiptRoute = <Route path={ROUTES.BOOK_KVITTERING} component={BookReciept} />;

   


    orderFlowRoute = <Route path={'/:page/:movieId/:showtimeId'} component={OrderFlowContainer} />;
    reservationRoute = <Route path={'/:page/:reservationId'} component={OrderFlowContainer} />;
    qRoute = <Route path={'/:page/:reservationId'} component={OrderFlowContainer} />


    commercialsRoute = <Route exact path={ROUTES.COMMERCIALS} component={CommercialsContainer} />;

    userTransactionsRoute = <Route path={ROUTES.USER_TRANSACTIONS} component={TransactionsContainer} />;
    userNewslettersRoute = <Route path={ROUTES.NEWSLETTERS} component={NewslettersContainer} />;
    userNewslettersRoutev2 = <Route path={ROUTES.NEWSLETTERSV2} component={NewslettersContainerv2} />;

    // notFoundRoute = window.location.pathname === '/profile' || window.location.pathname === '/LOGIN' ||
    //    window.location.pathname === '/login' || window.location.pathname === '/newpassword' ||
    //     window.location.pathname === '/finishaccount' || window.location.pathname === '/createaccount' ||
    //     window.location.pathname === '/alle-kommende-film' || window.location.pathname === '/alle-trailere' || window.location.pathname === '/ebillet-biografer' ||
    //     window.location.pathname === '/ebillet'  ||
    //    window.location.pathname === '/ebillet-alle-film' || window.location.pathname === '/reepay-book-landing' ||
    //    window.location.pathname === '/book-kvittering' || window.location.pathname === '/film-details'  ? '' :
       
    //    < Route render={() => !this.props.isFecthing ? <NotFound /> : null} />;
   

    initializeApp(mode) {
        switch (mode) {
            case APP_MODES.PROGRAM:
                return <Switch>
                    {this.ticketMasterAllEventsRoute}
                    {this.ticketMasterEventRoute}
                    {this.billettenAllEventsRoute}
                    {this.billettenEventRoute}

                    {this.multiAllMoviesRoute}
                    {this.multiProgramRoute}
                    {this.multiFutureMoviesRoute}
                    {this.multiMovieRoute}

                    {/* MULTI MOVIES routes */}
                    {this.multiAllMoviesRouteV2}
                    {this.multiProgramRouteV2}
                    {this.multiFutureMoviesRouteV2}

                    {this.filmClubRoute}
                    {this.filmClubOrderFlowRoute}
                    {this.FilmClubCustomerContainerRoute}
                    {this.FilmClubReepayContainerRoute}
                    {this.FilmClubReceiptContainerRoute}
                    {this.FilmClubReepayLandingPage}
                    {this.filmClubOrderContainer}
                    {this.altaPayMulti}

                     {/*new book route*/}
                    {this.bookReceiptRoute}
                    {this.reepayLandingRoute}



                    {this.commercialsRoute}

                    {this.program_AllFutureMoviesRoute}
                    {this.program_AllFutureMoviesRouteV2 }

                    {this.programRoute}
                    {this.programV2Route}
                    {/* week program routes */}
                     
                    {this.weekProgramRoute}
                    {this.weekProgramRoute2}

                    {/* week program v2 */}
                    {this.weekProgramRoute2V2 }

                    {this.speicalEventsRoute}
                    {this.allMoviesRoute}

                    {this.allMoviesRouteV2}

                    {this.futureMoviesRoute}
                    {this.futureMoviesRouteV2 } 
                    {this.circusRoute}

                    {this.movieRoute}
                    {this.movieRouteV2}
                    {this.multiMovieRouteV2 }

                    {this.orderFlowRoute}
                    {this.reservationRoute}
                    {this.qRoute}
                   
                    {this.userTransactionsRoute}
                    {this.userNewslettersRoute}
                    {this.userNewslettersRoutev2}

                    {this.notFoundRoute}

                    {this.loginRoute}
                    {this.logoutRoute}
                    {this.createAccountRoute}
                    {this.finishAccountRoute}
                    {this.resetPasswordRoute}
                    {this.resetPasswordSuccessRoute}
                  
                    {this.profileRoute }
                    {/*{this.newPasswordRoute }*/}
                  
                 
                

                    {/* EBILLET WEBSITE ROUTES */}
                    {this.ebilletHomeRoute}
                    {/*{this.ebilletProgramRoute}*/}
                    {this.ebilletAllMoviesRoute}
                    {this.EbilletMovieDetails}
                    {this.ebilletBiografRoute}
                    {this.ebilletAllTrailers}
                    {this.allFutureFilmRoute}

                   
                </Switch>

           
           
            case APP_MODES.MOVIE:
                return <Switch>
                    {this.movieRoute}
                    {this.movieRouteV2}
                    {this.multiMovieRouteV2}
                    {this.loginFlowRoute}

                    {this.orderFlowRoute}
                    {this.reservationRoute}
                    {this.qRoute}
                    {this.notFoundRoute}
           
                </Switch>
         
          
            case APP_MODES.ORDERFLOW:
                return <Switch>
                    {this.orderFlowRoute}
                    {this.reservationRoute}
                    {this.qRoute}
                    

                    {this.notFoundRoute}

                </Switch>

          
            default:
                {
                    const error = { message: 'Siden kunne ikke initialiseres', debug: 'DEBUG: App.js could not determine app mode' };
                    return /*<Error error={error} />*/
                }
        }
    }

    render() {

        const { mode, site_type } = this.props;
        const { app }  = this.state;

        return (
            <div className={window.location.pathname === '/alle-kommende-film' || window.location.pathname === '/alle-trailere' ||
                window.location.pathname === '/ebillet-biografer' || window.location.pathname === '/ebillet' || window.location.pathname == '/ebillet-program' ||
                window.location.pathname == '/film-details' || window.location.pathname == '/ebillet-alle-film' ? 'App-ebillet' : "App"}
                onLoad={this.checkIfAppHeightChanged}>
                {/*<Spinner />*/}
                <div className={window.location.pathname.includes('/film-infov2') || window.location.pathname.includes('/multibio-film-infov2')
                                || window.location.pathname === '/programv2'
                                || window.location.pathname === '/program-og-fremtidige-filmv2'
                                || window.location.pathname === '/alle-filmv2' 
                                || window.location.pathname === '/uge-program2v2'  
                                || window.location.pathname === '/kommende-filmv2'
                                || window.location.pathname === '/multibio-programv2'
                                || window.location.pathname === '/multibio-alle-filmv2'
                                || window.location.pathname === '/multibio-programv2'
                                || window.location.pathname === '/multibio-kommende-filmv2'
                                || site_type == 3

                    ? 'programv2'
                    : window.location.pathname === '/profile' || window.location.pathname === '/login' || window.location.pathname === '/newpassword' ||
                        window.location.pathname === '/finishaccount' || window.location.pathname === '/createaccount' || window.location.pathname === '/resetpassword'
                        ? 'login-profile' || window.location.pathname ==='/test'
                    : 'content-wrapper ' + mode}>
                    {app}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        isFecthing: state.organizer.isFetching || state.movielist.isFetching || state.order.isFetching || state.customer.isFetching || state.receipt.isFetching || false,
        mode: state.organizer.configuration.appMode,
        pageHeight: state.app.height,
        site_type: state.app.siteType
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(Object.assign({}, { appHeightChanged, initFromParentSite }), dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))